import { FormField } from '@domgen/dgx-fe-forms/layout';
import { CmsPaperlessPreferenceFieldset } from './cms-paperless-preference-fieldset.interface';

export interface CmsDirectDebitForm {
  accountHolderConfirmationField: FormField;
  accountNameField: FormField;
  accountNumberField: FormField;
  ibanField: FormField;
  paperlessPreferenceFieldset: CmsPaperlessPreferenceFieldset;
  paymentDateField: FormField;
  sortCodeField: FormField;
}
